import doc                            from '@widesk-core/decorators/doc';
import AbstractEventWorkflowTypeModel from './AbstractEventWorkflowTypeModel';
import model                          from '@widesk-core/decorators/model';
import { ShapeMode }                  from '@/components/Shape';

@doc.urnResource('event_workflow_type')
@model.cacheDuration()
export default class EventWorkflowTypeModel extends AbstractEventWorkflowTypeModel {
	public get shape(): ShapeMode {
		switch (this.reference) {
			case 'communication':
				return 'hexagon';
			case 'programming':
				return 'triangle';
			case 'planification':
				return 'square';
		}
	}
}
